// Trisé Bistrot — Menù estivo (Summer menu). Prices in EUR.
// Numbers in `allergens` are the allergen codes printed on the menu.
// Easily editable: change it/en/desc/price here.

export const MENU = [
  {
    id: "pranzo",
    it: "Menu pranzo",
    en: "Lunch menu",
    number: "—",
    blurb: {
      it: [
        "Ogni giorno qualcosa di nuovo, fresco e genuino. Per sentirti a casa, anche in pausa pranzo.",
        "A pranzo trovi sempre le nostre insalate, i sandwich e tante proposte del giorno da scoprire.",
        "La lavagna cambia continuamente, seguendo ingredienti, stagioni e ispirazione della cucina. Per questo, ogni pranzo al Trisé può essere diverso.",
        "Un pranzo veloce, curato e pieno di gusto, a due passi dal Parco Archeologico della Neapolis.",
        "Vieni a scoprire cosa c'è oggi sulla lavagna.",
      ],
      en: [
        "Every day something new, fresh and genuine. To feel at home, even on your lunch break.",
        "At lunch you'll always find our salads, sandwiches and plenty of daily specials to discover.",
        "The blackboard changes constantly, following ingredients, seasons and the kitchen's inspiration. That's why every lunch at Trisé can be different.",
        "A quick, refined and flavour-packed lunch, steps from the Neapolis Archaeological Park.",
        "Come and discover what's on the board today.",
      ],
    },
    items: [
      { sub: true, it: "Insalate", en: "Salads" },
      {
        it: "Chicken Salad",
        desc_it: "Misticanza, tagliata di pollo in CBT, scaglie di grana, crostini di pane, salsa yogurt",
        en: "Chicken Salad",
        desc_en: "Mixed greens, low-temperature cooked chicken, parmesan shavings, bread croutons, yogurt dressing",
        allergens: "3 · 9",
        price: "13",
      },
      {
        it: "Caprese Salad",
        desc_it: "Misticanza, pomodoro, erba cipollina, mozzarella e basilico",
        en: "Caprese Salad",
        desc_en: "Mixed greens, tomato, chives, mozzarella and basil",
        allergens: "3",
        price: "8",
      },
      {
        it: "Fish Salad",
        desc_it: "Misticanza, salmone/spada affumicato, zucchine, guacamole e dressing agli agrumi",
        en: "Fish Salad",
        desc_en: "Mixed greens, smoked salmon/swordfish, zucchini, guacamole and citrus dressing",
        allergens: "5",
        price: "14",
      },
      {
        it: "Veg Salad",
        desc_it: "Misticanza, uova, mandorle, pomodoro, olive nere",
        en: "Veg Salad",
        desc_en: "Mixed greens, eggs, almonds, tomato, black olives",
        allergens: "2 · 13 · 14",
        price: "10",
      },
      { sub: true, it: "Sandwich", en: "Sandwiches" },
      {
        it: "Chicken Sandwich",
        desc_it: "Sfoglie di pollo, bacon, maionese, lattuga, pomodoro",
        en: "Chicken Sandwich",
        desc_en: "Chicken slices, bacon, mayonnaise, lettuce, tomato",
        allergens: "9 · 14",
        price: "13",
      },
      {
        it: "Fish Sandwich",
        desc_it: "Salmone/spada affumicato, salsa guacamole, pomodoro, lattuga, maionese",
        en: "Fish Sandwich",
        desc_en: "Smoked salmon/swordfish, guacamole sauce, tomato, lettuce, mayonnaise",
        allergens: "5 · 9 · 14",
        price: "14",
      },
      {
        it: "Trisèndwich veg",
        desc_it: "Verdure croccanti, pesto di mandorle, pomodoro, mozzarella, basilico",
        en: "Trisèndwich veg",
        desc_en: "Crunchy vegetables, almond pesto, tomato, mozzarella, basil",
        allergens: "2 · 3 · 9",
        price: "10",
      },
      { sub: true, it: "Al piatto", en: "Plates" },
      {
        it: "Cotoletta di melanzane",
        desc_it: "3 pezzi",
        en: "Eggplant cutlet",
        desc_en: "3 pieces",
        allergens: "",
        price: "5",
      },
      {
        it: "Polpette al sugo",
        desc_it: "3 pezzi",
        en: "Meatballs in sauce",
        desc_en: "3 pieces",
        allergens: "",
        price: "8",
      },
      {
        it: "Polpette bianche",
        desc_it: "3 pezzi",
        en: "White meatballs",
        desc_en: "3 pieces",
        allergens: "",
        price: "8",
      },
      {
        it: "Sovracoscia di pollo",
        en: "Chicken thigh",
        allergens: "",
        price: "12",
      },
      {
        it: "Burger al piatto",
        desc_it: "Cacio, bacon, pomodoro, misticanza, bbq e maionese",
        en: "Burger plate",
        desc_en: "Cheese, bacon, tomato, mixed greens, bbq and mayonnaise",
        allergens: "3 · 9 · 14",
        price: "13",
      },
      { sub: true, it: "Per accompagnare", en: "Sides", range: "5" },
      { it: "Verdure grigliate", en: "Grilled vegetables", allergens: "", price: "5" },
      { it: "Verdure gratinate", en: "Vegetables au gratin", allergens: "", price: "5" },
      { it: "Caponata", en: "Caponata", allergens: "", price: "5" },
      { it: "Patate al forno", en: "Baked potatoes", allergens: "", price: "5" },
      { it: "Parmigiana di melanzane", en: "Eggplant parmigiana", allergens: "", price: "7" },
      { sub: true, it: "Cose buone", en: "Good things" },
      {
        it: "Orecchiette zucca, speck e scamorza",
        en: "Orecchiette with pumpkin, speck and scamorza",
        allergens: "",
        price: "8",
      },
      {
        it: "Lasagna bianca, carciofi e funghi",
        en: "White lasagna with artichokes and mushrooms",
        allergens: "",
        price: "9",
      },
      {
        it: "Ravioli melanzane e scamorza con crema di pomodorino giallo",
        en: "Eggplant and scamorza ravioli with yellow tomato cream",
        allergens: "",
        price: "9",
      },
    ],
  },
  {
    id: "starter",
    it: "Per iniziare",
    en: "Starters",
    number: "01",
    items: [
      {
        it: "Bruschetta, gorgonzola, zucchine, miele e menta",
        en: "Bruschetta with gorgonzola, zucchini, honey and mint",
        allergens: "3 · 5 · 9",
        price: "6",
      },
      {
        it: "Bruschetta, stracciatella di burrata, pomodorino confit, alici e zest di limone",
        en: "Bruschetta with burrata stracciatella, confit cherry tomato, anchovies and lemon zest",
        allergens: "3 · 5 · 9",
        price: "6",
      },
      {
        it: "Bruschetta, tuma, crumble di pancetta e noci",
        en: "Bruschetta with tuma cheese, bacon crumble and walnuts",
        allergens: "2 · 3 · 9",
        price: "6",
      },
      {
        it: "Bruschetta, caponata di zucchine e mandorle con crosta di parmigiano al basilico",
        en: "Bruschetta with zucchini caponata and almonds, basil parmigiano crust",
        allergens: "2 · 3 · 9 · 13",
        price: "6",
      },
      {
        it: "Caponata di zucchine al cioccolato e mandorle",
        en: "Sweet-and-sour Sicilian zucchini caponata with chocolate and almonds",
        allergens: "2 · 3 · 7 · 13",
        price: "6",
      },
      {
        it: "Parmigiana di melanzane, prosciutto cotto, pomodoro, caciocavallo e basilico",
        en: "Eggplant parmigiana with ham, tomato, caciocavallo cheese and basil",
        allergens: "3 · 6",
        price: "7",
      },
      {
        it: "Costatine BBQ e crema di patate al timo",
        en: "BBQ pork ribs with thyme potato cream",
        allergens: "2 · 7 · 11 · 13",
        price: "8",
      },
      {
        it: "Polpo laccato su crema di ceci, sesamo e menta con crumble di pancetta",
        en: "Glazed octopus on chickpea cream, sesame and mint with bacon crumble",
        allergens: "4 · 6",
        price: "14",
      },
    ],
  },
  {
    id: "tartare",
    it: "Tartare",
    en: "Raw selection",
    number: "02",
    items: [
      {
        it: "Tartare di vitello, stracciatella di burrata e taralli sbriciolati",
        en: "Veal tartare, burrata stracciatella and crumbled taralli",
        allergens: "3 · 9",
        price: "16",
      },
      {
        it: "Tartare di tonno rosso, dadolata di mango, panko e salsa di anguria e albicocca",
        en: "Red tuna tartare, diced mango, panko and watermelon-apricot sauce",
        allergens: "5 · 9",
        price: "16",
      },
      {
        it: "Tartare di gamberi rosa, pesca tabacchiera, passion fruit, sfere di basilico e menta, crema di piselli e julienne di patate croccanti",
        en: "Pink shrimp tartare, flat peach, passion fruit, basil & mint pearls on pea cream and crispy potato julienne",
        allergens: "8",
        price: "16",
      },
    ],
  },
  {
    id: "mains",
    it: "Piatti principali",
    en: "Mains",
    number: "03",
    items: [
      {
        it: "Cuberoll di manzo, patate al forno, tzatziki e glassa di teriyaki",
        en: "Grilled beef cube roll, roasted potatoes, tzatziki and teriyaki glaze",
        allergens: "3 · 7 · 9 · 13",
        price: "19",
      },
      {
        it: "Tagliata di pollo in CBT, songino, zucchine, pomodoro e salsa yogurt",
        en: "Low-temperature chicken, lamb's lettuce, zucchini, tomato and yogurt sauce",
        allergens: "3",
        price: "17",
      },
      {
        it: "Trisé Beef Burger — 200g di manzo, caciocavallo, pomodoro, pancetta, maionese e salsa BBQ, con patate al forno",
        en: "Trisè beef burger — 200g patty, caciocavallo, tomato, bacon, mayo, BBQ sauce, with roasted potatoes",
        allergens: "3 · 9 · 14",
        price: "14",
      },
      {
        it: "Tonno in crosta di sesamo e papavero, tortino di zucchine e carote e riduzione di agrumi",
        en: "Sesame and poppy-seed crusted tuna, zucchini and carrot flan, citrus reduction",
        allergens: "5 · 6",
        price: "19",
      },
      {
        it: "Norma",
        desc_it: "Pasta fresca, passata di pomodoro, melanzane, ricotta salata e basilico",
        en: "Norma",
        desc_en: "Fresh pasta, tomato sauce, eggplant, salted ricotta and basil",
        allergens: "3 · 9",
        price: "12",
      },
      {
        it: "Siracusana",
        desc_it: "Pasta fresca, crema di alici, croccante di pangrattato agli agrumi, noci, uvetta, capperi e zest di lime",
        en: "Siracusana",
        desc_en: "Fresh pasta, creamed anchovies, citrus breadcrumbs, walnuts, raisins, capers and lime zest",
        allergens: "2 · 5 · 9",
        price: "14",
      },
      {
        it: "Lasagna al ragù bianco di maiale con fonduta di parmigiano",
        en: "Lasagna with white pork ragù and parmesan fondue",
        allergens: "",
        price: "16",
      },
    ],
  },
  {
    id: "daily",
    it: "Piatti del giorno",
    en: "Daily specials",
    number: "—",
    items: [
      {
        it: "Fuori menù, ogni giorno",
        desc_it: "Chiedi in sala le proposte del giorno: cambiano secondo il mercato e la stagione.",
        en: "Off-menu, every day",
        desc_en: "Ask our staff about today's specials: they change with the market and the season.",
        allergens: "",
        price: "",
      },
    ],
  },
  {
    id: "salads",
    it: "Insalate e Panini",
    en: "Salads & Panini",
    number: "04",
    items: [
      {
        it: "Salmon Salad",
        desc_it: "Misticanza, salmone affumicato, zucchine, guacamole e dressing agli agrumi",
        en: "Salmon Salad",
        desc_en: "Mixed greens, smoked salmon, zucchini, guacamole and citrus dressing",
        allergens: "5",
        price: "14",
      },
      {
        it: "Chicken Salad",
        desc_it: "Misticanza, tagliata di pollo in CBT, uova sode, scaglie di grana, crostini, salsa yogurt",
        en: "Chicken Salad",
        desc_en: "Mixed greens, low-temperature chicken, boiled eggs, parmesan, croutons, yogurt dressing",
        allergens: "3 · 9 · 14",
        price: "13",
      },
      {
        it: "Burrata Salad",
        desc_it: "Misticanza, pomodoro, erba cipollina, burrata, ricotta salata e basilico",
        en: "Burrata Salad",
        desc_en: "Mixed greens, tomato, chives, burrata, salted ricotta and basil",
        allergens: "3",
        price: "10",
      },
      {
        it: "Panino al pollo",
        desc_it: "Sfoglie di pollo, uovo, bacon, maionese, lattuga e pomodoro — con chips di patate",
        en: "Chicken Sandwich",
        desc_en: "Chicken slices, egg, bacon, mayo, lettuce and tomato — with potato chips",
        allergens: "9 · 14",
        price: "13",
      },
      {
        it: "Panino al pesce",
        desc_it: "Salmone affumicato, guacamole, pomodoro, lattuga e maionese — con chips di patate",
        en: "Fish Sandwich",
        desc_en: "Smoked salmon, guacamole, tomato, lettuce and mayo — with potato chips",
        allergens: "5 · 9 · 14",
        price: "14",
      },
    ],
  },
  {
    id: "kids",
    it: "Menu Kids",
    en: "Kids menu",
    number: "—",
    items: [
      {
        it: "Pasta fresca al pomodoro",
        en: "Fresh tomato pasta",
        allergens: "9",
        price: "8",
      },
      {
        it: "Cotoletta di pollo servita con chips di patate",
        en: "Chicken cutlet served with potato chips",
        allergens: "3 · 9",
        price: "12",
      },
      {
        it: "Hamburger di manzo servito con chips di patate",
        en: "Beef burger served with potato chips",
        allergens: "3 · 9",
        price: "11",
      },
    ],
  },
  {
    id: "dessert",
    it: "Piccoli piaceri",
    en: "Dessert",
    number: "05",
    items: [
      {
        it: "Tiramisù",
        en: "Tiramisù",
        allergens: "3 · 9 · 14",
        price: "7",
      },
      {
        it: "Tortino al cioccolato",
        desc_it: "con gelato (vaniglia/cioccolato)",
        en: "Seasonal chocolate cake",
        desc_en: "with ice cream (vanilla/chocolate)",
        allergens: "2 · 3 · 9 · 14",
        price: "7",
      },
      {
        it: "Cannolo scomposto di ricotta",
        en: "Deconstructed ricotta cannolo",
        allergens: "3 · 9",
        price: "7",
      },
      {
        it: "Cheese cake",
        desc_it: "(fragola, caramello salato, nutella)",
        en: "Cheese cake",
        desc_en: "(strawberry, salted caramel, nutella)",
        allergens: "3 · 9",
        price: "7",
      },
      {
        it: "Torta all'arancia",
        en: "Orange cake",
        allergens: "3 · 9 · 14",
        price: "7",
      },
    ],
  },
  {
    id: "drink",
    it: "Drink",
    en: "Drinks",
    number: "—",
    items: [
      { sub: true, it: "Cocktail", en: "Cocktails" },
      { it: "Aperol Spritz", en: "Aperol Spritz", allergens: "", price: "" },
      { it: "Americano", en: "Americano", allergens: "", price: "" },
      { it: "Black Russian", en: "Black Russian", allergens: "", price: "" },
      { it: "Boulevardier", en: "Boulevardier", allergens: "", price: "" },
      {
        it: "Gin Tonic",
        desc_it: "Noto, Tanqueray, Del Professore Monsieur, Del Professore Madame, Bombay, Monkey 47, Mare, Hendrick's, Roku, No.3",
        en: "Gin & Tonic",
        desc_en: "Noto, Tanqueray, Del Professore Monsieur, Del Professore Madame, Bombay, Monkey 47, Mare, Hendrick's, Roku, No.3",
        allergens: "",
        price: "",
      },
      { it: "Manhattan", en: "Manhattan", allergens: "", price: "" },
      { it: "Margarita", en: "Margarita", allergens: "", price: "" },
      { it: "Mojito", en: "Mojito", allergens: "", price: "" },
      { it: "Moscow Mule", en: "Moscow Mule", allergens: "", price: "" },
      { it: "Negroni", en: "Negroni", allergens: "", price: "" },
      { it: "Negroni Sbagliato", en: "Negroni Sbagliato", allergens: "", price: "" },
      { it: "Whiskey Sour", en: "Whiskey Sour", allergens: "", price: "" },
      { it: "White Lady", en: "White Lady", allergens: "", price: "" },
      { it: "Gin Basil Smash", en: "Gin Basil Smash", allergens: "", price: "" },
      { it: "Paloma", en: "Paloma", allergens: "", price: "" },
      { sub: true, it: "Vini", en: "Wines" },
      {
        it: "Calice di vino",
        desc_it: "(rosso, bianco, rosato, bollicine)",
        en: "Glass of wine",
        desc_en: "(red, white, rosé, sparkling)",
        allergens: "",
        price: "7",
      },
      {
        it: "Carta dei vini",
        desc_it: "Chiedi in sala la nostra selezione.",
        en: "Wine list",
        desc_en: "Ask our staff for our selection.",
        allergens: "",
        price: "",
      },
      { sub: true, it: "Birre", en: "Beers", range: "4–5" },
      {
        it: "Norbertus",
        desc_it: "(bionda, rossa)",
        en: "Norbertus",
        desc_en: "(blonde, red)",
        allergens: "",
        price: "5",
      },
      {
        it: "Raffo",
        en: "Raffo",
        allergens: "",
        price: "4",
      },
      {
        it: "Messina",
        en: "Messina",
        allergens: "",
        price: "4",
      },
      {
        it: "Nastro Azzurro",
        en: "Nastro Azzurro",
        allergens: "",
        price: "4",
      },
      {
        it: "Daura",
        desc_it: "(gluten free)",
        en: "Daura",
        desc_en: "(gluten free)",
        allergens: "",
        price: "5",
      },
      { sub: true, it: "Caffetteria", en: "Coffee" },
      {
        it: "Espresso",
        en: "Espresso",
        allergens: "",
        price: "1,50",
      },
      {
        it: "Cappuccino",
        en: "Cappuccino",
        allergens: "",
        price: "2",
      },
      {
        it: "Americano",
        en: "Americano",
        allergens: "",
        price: "3",
      },
      {
        it: "Doppio espresso",
        en: "Double espresso",
        allergens: "",
        price: "3",
      },
      {
        it: "Decaffeinato",
        en: "Decaf",
        allergens: "",
        price: "1,50",
      },
      { sub: true, it: "Analcolici", en: "Soft drinks" },
      {
        it: "Crodino",
        en: "Crodino",
        allergens: "",
        price: "4",
      },
      {
        it: "Campari Soda",
        en: "Campari Soda",
        allergens: "",
        price: "4",
      },
      {
        it: "Ginger beer",
        en: "Ginger beer",
        allergens: "",
        price: "4",
      },
      {
        it: "Ginger ale",
        en: "Ginger ale",
        allergens: "",
        price: "4",
      },
      {
        it: "Pink grapefruit",
        en: "Pink grapefruit",
        allergens: "",
        price: "4",
      },
      {
        it: "Tonica Fever Tree",
        en: "Fever Tree tonic",
        allergens: "",
        price: "4",
      },
      {
        it: "Limonata",
        en: "Lemonade",
        allergens: "",
        price: "4",
      },
      {
        it: "Coca Cola / Zero",
        en: "Coca Cola / Zero",
        allergens: "",
        price: "3",
      },
      {
        it: "Fanta",
        en: "Fanta",
        allergens: "",
        price: "3",
      },
      {
        it: "Sprite",
        en: "Sprite",
        allergens: "",
        price: "3",
      },
      {
        it: "Chinotto",
        en: "Chinotto",
        allergens: "",
        price: "3",
      },
      { sub: true, it: "Amari", en: "Amari", range: "4" },
      { it: "Nepeta", en: "Nepeta", allergens: "", price: "4" },
      { it: "Majora", en: "Majora", allergens: "", price: "4" },
      { it: "Timous", en: "Timous", allergens: "", price: "4" },
      { it: "Amara", en: "Amara", allergens: "", price: "4" },
      { it: "Unicum", en: "Unicum", allergens: "", price: "4" },
      { it: "Del Capo", en: "Del Capo", allergens: "", price: "4" },
      { it: "Caffè Borghetti", en: "Caffè Borghetti", allergens: "", price: "4" },
      { it: "Montenegro", en: "Montenegro", allergens: "", price: "4" },
      { it: "Jägermeister", en: "Jägermeister", allergens: "", price: "4" },
    ],
  },
];
